"use client";
import * as React from "react";

interface SelectProps {
  label: string;
  id?: string;
  name: string;
  options: Array<{
    value: string;
    text: string;
  }>;
  classNames?: {
    select?: string;
    label?: string;
  };
  disabled?: boolean;
  selectedValue: string;
  handleChange: (event: any) => void;
}

import styles from "./index.module.css";
import Spacer from "../Spacer/index";
import cssClassAssembler from "../../sso/utils/cssClassAssembler";

function Select(props: SelectProps) {
  function id() {
    return props.id ? props.id : props.label.replace(/ /g, "");
  }

  function cssClass() {
    return {
      div: styles.div + (props.disabled ? ` ${styles["div--disabled"]}` : ""),
      select: cssClassAssembler(props.classNames?.select, styles.select),
      label: cssClassAssembler(props.classNames?.label, styles.label),
    };
  }

  return (
    <>
      <label htmlFor={id()} className={cssClass().label}>
        {props.label}
      </label>
      <Spacer y={2} />
      <div className={cssClass().div}>
        <select
          id={id()}
          name={props.name}
          className={cssClass().select}
          disabled={props.disabled ?? false}
          value={props.selectedValue}
          onChange={(event) => props.handleChange(event)}
        >
          {props.options?.map((optionItem) => (
            <option value={optionItem.value} key={optionItem.value}>
              {optionItem.text}
            </option>
          ))}
        </select>
        <span />
      </div>
    </>
  );
}

export default Select;
